import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs'
import WhatsAppLogsList from './WhatsAppLogsList';
import SMSLogsList from './SMSLogsList';
import EmailLogsList from './EmailLogsList';
import ActivityRegisterController from '../../../../Controllers/AdminScreens/Configuration/ActivityRegister/ActivityRegisterController';
import Loader from "../../../../../Components/Loader";



const ActivityRegisterScreen = () => {
    const{
        whatsAppLogLoading,
        whatsAppLogError,
        whatsAppLogList,
        setwhatsAppLogLoading,
        setwhatsAppLogError,
        setwhatsAppLogList,
        fetchWhatsppLogList,
        emailLogLoading, 
        setEmailLogLoading,
        emailLogError, setEmailLogError,
        emailLogList, setEmailLogList,
        fetchEmailLogList,
        smsLogLoading, 
    setSmsLogLoading,
    smsLogError, 
    setSmsLogError,
    smsLogList,
    setSmsLogList,
    fetchSmsLogList,
    tabs,
    userLoading,
    userError,
    recipientOptions,
    contactListLoading,
    contactListError,
    contactListList,
   } = ActivityRegisterController()
    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };
    
    const handleRefreshAllTabs = () => {
        fetchWhatsppLogList();
        fetchEmailLogList();
        fetchSmsLogList();
        };
    // const {

    // } = InvoiceSettingsController()
    
    console.log("whatsAppLogError",whatsAppLogError)
    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:10}}>
                <h2 className='title'>Activity Register</h2>
            </div>

            <div >
            <Tabs tabs={tabs}
            selectedIndex={selectedTab}
            onTabChange={handleTabChange}>
                {tabs.map((tab) => {
                        switch (tab) {
                            case 'WhatsApp Logs':
                                return (
                                    <WhatsAppLogsList setwhatsAppLogList={setwhatsAppLogList} whatsAppLogList={whatsAppLogList} whatsAppLogError={whatsAppLogError} setwhatsAppLogError={setwhatsAppLogError} setwhatsAppLogLoading={setwhatsAppLogLoading} whatsAppLogLoading={whatsAppLogLoading} onRefresh={fetchWhatsppLogList}
                                    userLoading= {userLoading} userError={userError} recipientOptions={recipientOptions} contactListLoading={contactListLoading} contactListError={contactListError} contactListList={contactListList}/>
                                );
                            case 'Email Logs':
                                return (
                                    <EmailLogsList setEmailLogList={setEmailLogList} emailLogList={emailLogList} emailLogError={emailLogError} setEmailLogError={setEmailLogError} setEmailLogLoading={setEmailLogLoading} emailLogLoading={emailLogLoading} onRefresh={fetchEmailLogList}
                                    userLoading= {userLoading} userError={userError} recipientOptions={recipientOptions} contactListLoading={contactListLoading} contactListError={contactListError} contactListList={contactListList}/>
                                );
                            case 'SMS Logs':
                                return (
                                    <SMSLogsList setSmsLogList={setSmsLogList} smsLogList={smsLogList} smsLogError={smsLogError} setSmsLogError={setSmsLogError} setSmsLogLoading={setSmsLogLoading} smsLogLoading={smsLogLoading} onRefresh={fetchSmsLogList}
                                    userLoading= {userLoading} userError={userError} recipientOptions={recipientOptions} contactListLoading={contactListLoading} contactListError={contactListError} contactListList={contactListList}/>
                                );
                            default:
                                return null;
                        }
                    })}
                </Tabs>
            </div>
        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default ActivityRegisterScreen;